export default __webpack_public_path__ + "static/media/Marvel@3x.38f2826c.png";